import { render, staticRenderFns } from "./PartnerDetails.vue?vue&type=template&id=098ae2f5"
import script from "./PartnerDetails.vue?vue&type=script&lang=ts"
export * from "./PartnerDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports